import { SVGInterface } from "../../interface";

const PlaceChart = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C16.725 1 21 4.542 21 10.02C21 13.672 17.9963 17.995 12 23C6.00375 17.995 3 13.672 3 10.02C3 4.542 7.275 1 12 1ZM18.75 10.02C18.75 5.82435 15.5524 3.2 12 3.2C8.44765 3.2 5.25 5.82435 5.25 10.02C5.25 11.253 5.76101 12.8181 7.11344 14.7676C8.22376 16.3681 9.8378 18.135 12 20.0666C14.1622 18.135 15.7762 16.3681 16.8866 14.7676C18.239 12.8181 18.75 11.253 18.75 10.02Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M10.875 13.1H8.625L8.625 8.7H10.875L10.875 13.1Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M15.375 13.1H13.125L13.125 6.5L15.375 6.5L15.375 13.1Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default PlaceChart;
